import { initCommerceApiWithGlobals } from 'common-api';
import { logger } from 'common-ui';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { cartAtom } from '../../../atoms/cartAtom';
import { notificationsAtom } from '../../../atoms/notificationsAtom';
import { cartNotification } from '../../../helpers/cartNotification';

export function useAddToCartWithAtgLegacyApi() {
  const [, setCartData] = useRecoilState(cartAtom);
  const setNotification = useSetRecoilState(notificationsAtom);

  return async (productSku: string, quantity: string): Promise<void> => {
    try {
      const commerceApi = initCommerceApiWithGlobals();
      const newCartData = await commerceApi.Cart.add(productSku, quantity);
      setCartData(prevState => ({
        ...prevState,
        cartIsLoaded: true,
        cartItems: {
          ...prevState.cartItems,
          ...newCartData,
        },
      }));
      const notification = cartNotification(productSku, quantity);
      setNotification([notification]);
    } catch (e) {
      logger.error('API ERROR', e);
      throw e;
    }
  };
}
